export default {
    methods:{
        Plural(value,form1,form2,form3){
            form2=form2||form1;
            form3=form3||form2;
            if(value>10 && Math.floor((value%100)/10)==1)
                return form3;
            switch(value%10){
                case 1: return form1;
                case 2:
                case 3:
                case 4: return form2;
                default: return form3;
            }
        }
    }
}